/* @ngInject */
function formatService (ConnectorWebService, CONSTANTS, Utils) {
  const service = {
    createFormat,
    getFormats,
    updateFormat,
    deleteFormat,
    migrateArts
  }
  return service

  function createFormat (queryParams) {
    return ConnectorWebService.post(CONSTANTS.URL_V2_FORMATS, queryParams)
  }

  function updateFormat (id, queryParams) {
    return ConnectorWebService.put(Utils.fnReplaceStringParams(CONSTANTS.URL_V2_FORMATS_ID, [id]), queryParams)
  }

  function deleteFormat (id) {
    return ConnectorWebService.fnDelete(Utils.fnReplaceStringParams(CONSTANTS.URL_V2_FORMATS_ID, [id]))
  }

  function migrateArts (queryParams) {
    const { id, targetFormatId } = queryParams
    return ConnectorWebService.post(Utils.fnReplaceStringParams(CONSTANTS.URL_V2_FORMATS_ID_ARTS_MIGRATE, [id]), { targetFormatId })
  }

  function getFormats (queryParams) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_V2_FORMATS_EXPANDED)

    if (queryParams) {
      const { search, authorsId, customerSpecific, sort, order, top, skip } = queryParams

      if (search) url = Utils.fnAddQueryToUrl(url, { search })
      if (authorsId) url = Utils.fnAddQueryToUrl(url, { authorsId })
      if (customerSpecific || !customerSpecific) url = Utils.fnAddQueryToUrl(url, { customerSpecific })
      if (sort) url = Utils.fnAddQueryToUrl(url, { $sort: sort })
      if (order) url = Utils.fnAddQueryToUrl(url, { $order: order })
      if (top) url = Utils.fnAddQueryToUrl(url, { $top: top })
      if (skip) url = Utils.fnAddQueryToUrl(url, { $skip: skip })
    }

    return ConnectorWebService.get(url)
  }
}

export { formatService }
